module.exports = __webpack_public_path__ + "static/media/5_1.05abc309.png";